import { createProvider } from '@/providers/apollo/vue-apollo'
export const apolloProvider = createProvider()
